module.exports = __webpack_public_path__ + "static/media/MediaImage.e6028338.png";